import { render, staticRenderFns } from "./ACard.vue?vue&type=template&id=08529bde&"
import script from "./ACard.vue?vue&type=script&lang=js&"
export * from "./ACard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports